<template lang="html">

  <article class="promocion-el row-center ais" :finished="data.finished">

    <div class="contenedor-imagen" :style="`background: url(${data.list.url}) center/cover no-repeat;`">
      <div class="contenedor-caducada row-center" v-if="data.finished">
        <img src="/static/img/promo-caducada.png" alt="Promoción caducada">
      </div>
    </div>
    <div class="contenedor-texto">
      <h2 class="titulo">{{data.titulo}}</h2>
      <!-- <h3 class="fecha">{{data.fecha.day}} {{$t(`years[${Number(data.fecha.month)-1}]`)}} {{data.fecha.year}}</h3> -->
      <p class="descripcion">{{data.entradilla}}</p>
    </div>

    <router-link v-if="!!!data.participation_redirect" class="enlace-cover" :to="$t('enlaces.promociones')+'/'+data.slug"></router-link>
    <a v-if="data.participation_redirect == 1" class="enlace-cover" :href="data.participation_url"></a>

  </article>

</template>

<script lang="js">
  
    import {mapGetters} from 'vuex';
  
    export default  {
      name: 'promocion-el',
      props : ['data']
  }
  </script>


// WEBPACK FOOTER //
// src/components/parts/promocion-el.vue